import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import theme from '../../styles/theme';

const MainWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    padding: 0.6rem 0px;
    height: 2rem;
    min-width: 4rem;
    line-height: 1.2rem;
    background: ${(props)=>props.color ? props.color : '#dddddd'};
    span {
        font-size: 1rem;
    }
`;


const ProjectStatusLabel = (props) => {
    const {status, value} = props;
    const [color, setColor] = useState();
    useEffect(()=>{
        if(status){
            let targetColor = theme.color.white[100];
            switch(status){
                case 'Q':
                case 'R':
                    targetColor = theme.color.request;
                    break;
                case 'I':
                    targetColor = theme.color.setting;
                    break;
                case 'S':
                    targetColor = theme.color.coding;
                    break;
                case 'E':
                    targetColor = theme.color.complete;
                    break;
            }
            setColor(targetColor);
        }
    },[status])
    return (
        <MainWrap color={color}>
            <span>{value}</span>
        </MainWrap>
    )
}

export default ProjectStatusLabel;
